import { ActionTypes } from './constants';
import { ActionCreator } from './models';

export const setScreenDefinitions: ActionCreator.SetScreenDefinitions = screenDefinitions => ({
  type: ActionTypes.SET_SCREEN_DEFINITIONS,
  payload: {
    screenDefinitions,
  },
});
